import { Box, Switch, Typography } from '@material-ui/core';
import { Explore } from '@material-ui/icons';
import React, { useEffect } from 'react';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useCampfireQuery } from '../../../../../global/network/useCampfireQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { GET_ALLOW_MULTI_PROGRAM_APPLICATION } from './admin-console-applicant-screening.gql';

export const MultiProgramApplicationForm = () => {
  const { setSnackbar } = useSnackbar();
  const [allowMultiProgram, setAllowMultiProgram] = React.useState(false);
  const apiUrl = useApiUrl();
  const campfireMutation = useCampfireFetch({ defer: true });

  const { data, refetch } = useCampfireQuery<any, undefined>(GET_ALLOW_MULTI_PROGRAM_APPLICATION);

  useEffect(() => {
    if (!data) return;
    setAllowMultiProgram(data.vm.configItem?.configItemValue?.flagValue ?? data.vm.configItem?.defaultValue ?? false);
  }, [data]);

  const onChange = () => {
    campfireMutation
      .run({
        url: `${apiUrl}/vm/admin-console/config`,
        method: 'post',
        data: {
          value: !allowMultiProgram,
          type: 'allow-multi-program-application',
        },
      })
      .then(() => {
        setSnackbar({
          variant: 'success',
          open: true,
          message: 'Settings updated',
        });
        refetch();
      });
  };

  return (
    <Box>
      <Typography style={{ fontWeight: 600, fontSize: '16px', display: 'flex', alignItems: 'center' }}>
        <Explore style={{ fontSize: '14px', paddingRight: '5px' }} /> Programs
      </Typography>
      <Typography variant={'body2'} style={{ fontSize: '14px', color: '#808080' }}>
        {'Settings related to program selection during onboarding'}
      </Typography>
      <Box display='flex' flex='1 1 auto' marginTop='1.5rem'>
        <Box style={{ paddingTop: 4, paddingRight: 8 }}>
          <Switch
            name='multi-program-application-toggle'
            color='primary'
            checked={allowMultiProgram}
            onChange={onChange}
            inputProps={{ 'aria-label': 'multi-program application toggle' }}
          />
        </Box>
        <Box>
          <Box ml={1}>
            <Typography
              style={{
                fontWeight: 500,
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                color: '#333',
              }}
            >
              Allow Multi-Program Selection
            </Typography>
            <Typography style={{ fontSize: '12px', color: '#808080' }}>
              Applicants will be able to select multiple programs during their profile setup. <br />
              When disabled, applicants can only select a single program.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
